/*
 *
 *  * Copyright(c) 2021 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {
  transform(value: any[], sortOrder = 'asc', propertyName?: string): any {
    sortOrder = sortOrder && (sortOrder.toLowerCase() as any);

    if (!value || (value && !value.length) || (sortOrder !== 'asc' && sortOrder !== 'desc')) return value;

    let numberArray, stringArray;

    if (!propertyName) {
      numberArray = value
        .filter(item => typeof item === 'number')
        .sort((a, b) => {
          return a - b;
        });
      // Sorting improvement has been registered as a possible enhancement
      stringArray = value.filter(item => typeof item === 'string').sort(); //NOSONAR
    } else {
      numberArray = value
        .filter(item => typeof item[propertyName] === 'number')
        .sort((a, b) => a[propertyName] - b[propertyName]);
      stringArray = value
        .filter(item => typeof item[propertyName] === 'string')
        .sort((a, b) => {
          if (a[propertyName] < b[propertyName]) return -1;
          else if (a[propertyName] > b[propertyName]) return 1;
          else return 0;
        });
    }
    const sorted = numberArray.concat(stringArray);
    return sortOrder === 'asc' ? sorted : sorted.reverse();
  }
}
